'use client'

import { CreditsShelfRoot } from './Root.js'
import { CreditsShelfProductsList } from './ProductsList.js'
import { CreditsProductCard } from './ProductCard.js'

// 导出类型
export type {
  CreditsShelfSemanticName,
  CreditsProductCardData,
  CopyConfig,
  ButtonFunctionType,
  CreditsShelfLayoutMode,
} from './types.js'

export type { CreditsShelfRootProps } from './Root.js'
export type { CreditsShelfProductsListProps } from './ProductsList.js'
export type { CreditsProductCardProps } from './ProductCard.js'
export type { CreditsShelfContextValue } from './context.js'

// 导出子组件
export { CreditsShelfRoot, CreditsShelfProductsList, CreditsProductCard }

// 组合式组件
const CreditsShelf = {
  Root: CreditsShelfRoot,
  ProductsList: CreditsShelfProductsList,
  ProductCard: CreditsProductCard,
}

export default CreditsShelf
